// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5716":"css/app.6927","6378":"css/admin-app.6927"}[chunkId] + ".css";
};